import { render } from "./TransformYourBrand.vue?vue&type=template&id=185cf1e4&scoped=true"
import script from "./TransformYourBrand.vue?vue&type=script&lang=js"
export * from "./TransformYourBrand.vue?vue&type=script&lang=js"

import "./TransformYourBrand.vue?vue&type=style&index=0&id=185cf1e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185cf1e4"]])

export default __exports__